import { useTraversal } from '@guillotinaweb/react-gmi'
import { useState } from 'react'
import { message } from 'antd'

export default function useSaveProduct() {
  const ctx = useTraversal()
  const [saving, setSaving] = useState(false)

  async function save(fields = {}, showMsg = false) {
    setSaving(true)
    try {
      const r = await ctx.client.patch(ctx.path, fields)
      if (r.status >= 400) throw new Error((await r.json()).message)
      setSaving(false)
      if (!showMsg) message.success(`Saved successfully.`)
      ctx.refresh({ transparent: true })
    } catch (e) {
      setSaving(false)
      message.error(`Error saving. ${e.message}`)
    }
  }

  return [saving, save]
}
